import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import { Button, UncontrolledPopover, PopoverBody } from 'reactstrap';
import classNames from 'classnames';

var Help = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Help, _React$Component);

  function Help(props) {
    return _React$Component.call(this, props) || this;
  }

  var _proto = Help.prototype;

  _proto.render = function render() {
    var _classNames;

    var helpClass = classNames('help-btn rounded-circle p-0 border-0 font-weight-bold', (_classNames = {}, _classNames["" + this.props.className] = this.props.className, _classNames));
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      id: this.props.id,
      className: helpClass,
      color: this.props.color,
      type: "button"
    }, "?"), /*#__PURE__*/React.createElement(UncontrolledPopover, {
      className: "help-btn__popover fade",
      trigger: "hover",
      placement: "right",
      target: this.props.id
    }, /*#__PURE__*/React.createElement(PopoverBody, null, this.props.body)));
  };

  return Help;
}(React.Component);

export { Help as default };
Help.defaultProps = {
  color: 'primary'
};